import { useCallback } from 'react';
import { UserSuggestion } from '../../common/use-user-suggestions';
import { MentionMenuItem } from '../mention-shared/mention-menu-item';

type MentionPickerListItemProps = {
  id?: string;
  user: UserSuggestion;
  isSelf: boolean;
  onClick: (mention: string, advocateId?: string) => void;
  onHover: () => void;
  selected: boolean;
};

const MentionPickerListItem = ({
  id,
  user,
  isSelf,
  onClick,
  onHover,
  selected,
}: MentionPickerListItemProps) => {
  const handleSelect = useCallback(() => {
    onClick(`@${user.display_name}`, user.id);
  }, [onClick, user.display_name, user.id]);

  return (
    <MentionMenuItem
      id={id}
      data={{
        id: user.id,
        // The "(you)" suffix is display-only. `MentionMenuItem` also feeds
        // this string to the avatar's initials calculation, so appending it
        // to `user.name` directly would derive initials from "(you)" instead
        // of the user's own name; `initialsFromName` strips a trailing
        // parenthetical token like this one for exactly that reason.
        name: isSelf ? `${user.name} (you)` : user.name,
        avatar: user.avatar,
        displayAttributes: user.display_attributes,
      }}
      isSelected={selected}
      onSelect={handleSelect}
      onHover={onHover}
    />
  );
};

export default MentionPickerListItem;
